import './style.css'
import GlobalSVG from '../../utils/GlobalSVG';
import Tooltip from "../../components/ToolTip";
export default function UnitToggle(props) {

    return (
        <div className="flex flex-nowrap justify-start items-center mt-3 w-full" >
            <div className='flex flex-nowrap justify-start w-full'>
                <div className={`toggle-left cursor-pointer w-1/2 ${props.options === props.option1 ? 'active' : ''}`} onClick={() => props.setOptions(props.option1)}>
                    {
                        props.options === props.option1 &&
                        GlobalSVG.checkSmall()
                    }
                    <span className='ml-2'>{props.button1}</span>
                </div>
                <div className={`toggle-right cursor-pointer w-1/2 ${props.options === props.option2 ? 'active' : ''}`} onClick={() => props.setOptions(props.option2)}>
                    <span className='mr-2'>{props.button2}</span>
                    {
                        props.options === props.option2 &&
                        GlobalSVG.checkSmall()
                    }
                </div>
            </div>
            {props.info && <Tooltip
                text={props.info}
                right="0"
                left="-600%"
                top="150%"
                width="200px"
                height="30px"
                textAlign="left"
                show={true}>
                <div className="ml-2">
                    {GlobalSVG.info('grey', '15', '15')}
                </div>
            </Tooltip>}
        </div>
    );
};